import { render } from "./IngredientList.vue?vue&type=template&id=140209ec"
import script from "./IngredientList.vue?vue&type=script&lang=js"
export * from "./IngredientList.vue?vue&type=script&lang=js"

import "./IngredientList.vue?vue&type=style&index=0&id=140209ec&lang=css"

import exportComponent from "/var/www/staging.no-menu.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__